<template>
  <ux-molecules-header-dropdown>
    <template #button>
      <span class="Nav-account">
        <span class="accessibility-sr-only" v-if="isMobile">{{ $t('ux.molecules.mainNav.accountButton') }}</span>
        <ux-atoms-icon class="Nav-account__icon--logged" name="account-logged" size="m" v-if="userStore.hasLoadedUser" />
        <ux-atoms-icon class="Nav-account__icon" name="account" size="m" v-else />

        <ux-atoms-typo
          :class="['Nav-account__label', { 'Nav-account__label--logged': userStore.hasLoadedUser }]"
          :color="'inherit'"
          :text="buttonLabel"
          as="span"
        />
      </span>
    </template>
    <template #content="slotProps">
      <ux-molecules-nav-account-dropdown @close::dropdown="slotProps.closeDropdown(true)" />
    </template>
  </ux-molecules-header-dropdown>
</template>
<script lang="ts" setup>
const { t } = useI18n();

const userStore = useUserStore();
const { isMobile } = useCurrentWindowSize();

const buttonLabel = computed(() => {
  return userStore.hasLoadedUser ? `${userStore.firstName} ${userStore.lastName}` : t('ux.molecules.navAccount.signinSignUp');
});
</script>
<style lang="scss" scoped>
@use 'NavAccount.scss';
</style>
